import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const data = {
    entity: {
        id: 0,
        codigo: "",
        nombre: "",
        edadMesesInicio: 0,
        edadMesesFin: 0,
        descripcion: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    validationActive: {
        codigo: false,
        nombre: false,
    },
    validationMessage: [],
  }
  
  export const skillSlice = createSlice({
    name: "skill",
    initialState: {},
    reducers: {
      init: (state, action) => {
        const { sliceKey } = action.payload;
        if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      },
      setEntity: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].entity = data;
      },
      setData: (state, action) => {
        var { sliceKey, name, value } = action.payload;
  
        if (name.startsWith("id")) value = parseInt(value)
        if (name.startsWith("edad")) value = parseInt(value)
        
        state[sliceKey].entity[name] = value
        state[sliceKey].validationActive[name] = true
      },
      setValidationMessage: (state, action) => {
        const {sliceKey, message} = action.payload;
        state[sliceKey].validationMessage = message;
      },
      activeValidations: (state, action) => {
        const {sliceKey} = action.payload;
        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
          state[sliceKey].validationActive[key] = true;
        })
      },
    },
  });
  
  export const { init, setEntity, setData, setValidationMessage, activeValidations } = skillSlice.actions;
  export const defaultEntity = {
    id: 0,
    codigo: "",
    nombre: "",
    edadMesesInicio: 0,
    edadMesesFin: 0,
    descripcion: "",
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
  }
  export default skillSlice.reducer;
  